import { render, staticRenderFns } from "./TopicsListAddNew.vue?vue&type=template&id=193b47d6&"
import script from "./TopicsListAddNew.vue?vue&type=script&lang=js&"
export * from "./TopicsListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./TopicsListAddNew.vue?vue&type=style&index=0&id=193b47d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports